import FlowCommand from "./FlowCommand";

class History {
  private undoStack: Array<FlowCommand> = []
  private redoStack: Array<FlowCommand> = []

  busy = false

  get hasUndo() {
    return !!this.undoStack.length
  }

  get hasRedo() {
    return !!this.redoStack.length
  }

  addToStack(action: FlowCommand) {
    if (!this.busy) {
      this.undoStack.push(action)
      this.redoStack = []
    }
  }

  undo() {
    const undoAction = this.undoStack.pop()

    if (undoAction) {
      this.busy = true

      undoAction.undo()
      this.redoStack.push(undoAction)

      this.busy = false
    }
  }

  redo() {
    const redoAction = this.redoStack.pop()

    if (redoAction) {
      this.busy = true

      this.undoStack.push(redoAction)
      redoAction.redo()

      this.busy = false
    }
  }

  getLastRecord() {
    return this.undoStack[this.undoStack.length - 1 ]
  }
}

export default new History()
